import React, { useState, useEffect } from 'react';
import subscriptionService from '../../services/subscription-service';
import './AdminSubscriptionSettings.scss';

const AdminSubscriptionSettings = () => {
  const [plans, setPlans] = useState([]);
  const [shotPrice, setShotPrice] = useState(75);
  const [smoothiePrice, setSmoothiePrice] = useState(120);
  const [premiumPrice, setPremiumPrice] = useState(100);
  const [offerName, setOfferName] = useState('Monsoon Immunity Shield');
  const [discountPercentage, setDiscountPercentage] = useState(33.33);
  const [showOffer, setShowOffer] = useState(true);
  const [loading, setLoading] = useState(false);
  const [loadingOffer, setLoadingOffer] = useState(false);

  useEffect(() => {
    loadPlans();
  }, []);

  const loadPlans = async () => {
    try {
      const plansData = await subscriptionService.getSubscriptionPlans();
      setPlans(plansData);
      if (plansData.length > 0) {
        const plan = plansData[0];
        setShotPrice(plan.shotPrice || 75);
        setSmoothiePrice(plan.smoothiePrice || 120);
        const premiumPlan = plansData.find(p => p.planType === 'premium');
        setPremiumPrice(premiumPlan?.premiumPrice || 100);
        
        // Load offer settings
        if (plan.offerSettings) {
          setOfferName(plan.offerSettings.offerName || 'Monsoon Immunity Shield');
          setDiscountPercentage(plan.offerSettings.discountPercentage || 33.33);
          setShowOffer(plan.offerSettings.showOffer !== false);
        }
      }
    } catch (error) {
      console.error('Error loading plans:', error);
    }
  };

  const updatePricing = async () => {
    setLoading(true);
    try {
      await subscriptionService.updatePlanPricing('all', shotPrice, smoothiePrice, premiumPrice);
      await loadPlans();
      alert('Pricing updated successfully!');
    } catch (error) {
      console.error('Error updating pricing:', error);
      alert('Error updating pricing: ' + error.message);
    }
    setLoading(false);
  };

  const updateOffer = async () => {
    setLoadingOffer(true);
    try {
      await subscriptionService.updateOfferSettings(offerName, discountPercentage, showOffer);
      await loadPlans();
      alert('Offer settings updated successfully!');
    } catch (error) {
      console.error('Error updating offer:', error);
      alert('Error updating offer: ' + error.message);
    }
    setLoadingOffer(false);
  };

  const calculatePrice = (plan) => {
    if (plan.planType === 'premium') {
      return plan.premiumPerMonth * premiumPrice;
    }
    return (plan.shotsPerMonth * shotPrice) + (plan.smoothiesPerMonth * smoothiePrice);
  };

  return (
    <div className="admin-subscription-settings">
      <h2>Subscription Pricing & Offers</h2>
      
      <div className="settings-section">
        <h3>💰 Pricing Settings</h3>
        <div className="pricing-controls">
          <div className="price-input">
            <label>Shot Price (₹)</label>
            <input
              type="number"
              value={shotPrice}
              onChange={(e) => setShotPrice(Number(e.target.value))}
              min="1"
            />
          </div>
          <div className="price-input">
            <label>Smoothie Price (₹)</label>
            <input
              type="number"
              value={smoothiePrice}
              onChange={(e) => setSmoothiePrice(Number(e.target.value))}
              min="1"
            />
          </div>
          <div className="price-input">
            <label>Premium Price (₹)</label>
            <input
              type="number"
              value={premiumPrice}
              onChange={(e) => setPremiumPrice(Number(e.target.value))}
              min="1"
            />
          </div>
          <button 
            onClick={updatePricing} 
            disabled={loading}
            className="update-btn"
          >
            {loading ? 'Updating...' : 'Update Pricing'}
          </button>
        </div>
      </div>

      <div className="settings-section">
        <h3>🎁 Offer Settings</h3>
        <div className="offer-controls">
          <div className="offer-input">
            <label>Offer Name</label>
            <input
              type="text"
              value={offerName}
              onChange={(e) => setOfferName(e.target.value)}
              placeholder="e.g., Monsoon Immunity Shield"
            />
          </div>
          <div className="offer-input">
            <label>Discount Percentage (%)</label>
            <input
              type="number"
              value={discountPercentage}
              onChange={(e) => setDiscountPercentage(Number(e.target.value))}
              min="0"
              max="100"
              step="0.01"
            />
          </div>
          <div className="offer-toggle">
            <label>
              <input
                type="checkbox"
                checked={showOffer}
                onChange={(e) => setShowOffer(e.target.checked)}
              />
              <span>Show Offer Badge</span>
            </label>
          </div>
          <button 
            onClick={updateOffer} 
            disabled={loadingOffer}
            className="update-btn offer-btn"
          >
            {loadingOffer ? 'Updating...' : 'Update Offer'}
          </button>
        </div>
      </div>

      <div className="plans-preview">
        <h3>Plan Pricing Preview</h3>
        {plans.map(plan => (
          <div key={plan.planType} className="plan-preview">
            <h4>{plan.name}</h4>
            <div className="calculation">
              {plan.planType === 'premium' ? (
                <span>{plan.premiumPerMonth} premium × ₹{premiumPrice} = ₹{plan.premiumPerMonth * premiumPrice}</span>
              ) : (
                <>
                  {plan.shotsPerMonth > 0 && (
                    <span>{plan.shotsPerMonth} shots × ₹{shotPrice} = ₹{plan.shotsPerMonth * shotPrice}</span>
                  )}
                  {plan.smoothiesPerMonth > 0 && (
                    <span>{plan.smoothiesPerMonth} smoothies × ₹{smoothiePrice} = ₹{plan.smoothiesPerMonth * smoothiePrice}</span>
                  )}
                </>
              )}
            </div>
            <div className="total">
              Monthly Total: ₹{calculatePrice(plan)}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AdminSubscriptionSettings;